import { useContext } from 'react';
import { PhotoContext } from '../context/PhotoProvider';
import { ProductTypes } from '../types/enums';

export const useProductType = () => {
  const { productType } = useContext(PhotoContext);

  const isMosaic = productType === ProductTypes.MOSAIC;
  const isEmbroidery = productType === ProductTypes.EMBROIDERY;

  return {
    productType,
    isMosaic,
    isEmbroidery,
  };
};
